import {INBOX_SERVICE_TYPES, NAV_MENU} from '@/config';

const baseSchema = {
    Admin: [
        'activateDevices',
        'allGenericRavRequest',
        'availablePrograms',
        'all-tasks',
        'backCare',
        'cardio-landing-page',
        'care-guide-activation',
        'healthInsightsReports',
        'bloodPressure',
        'bloodPressure.overview',
        'bloodPressure.trends',
        'bloodPressure.allLogs',
        'bloodPressure.summaryReports',
        'bloodPressure.personalizedReport',
        'bloodPressure.usingYourMonitor',
        'bloodSugar',
        'bloodSugar.overview',
        'bloodSugar.trends',
        'bloodSugar.allLogs',
        'bloodSugar.summaryReport',
        'bloodSugar.friendsAndFamily',
        'bloodSugar.shareFromMeter',
        'bodyComposition',
        'bodyComposition.allLogs',
        'bodyComposition.overview',
        'bodyComposition.getStarted',
        'bodyComposition.summaryReport',
        'carePlan',
        'careTeam',
        'ccmSso',
        'coaching',
        'coaching.coachingSession',
        'coaching.coachingSessionDetails',
        'coaching.goals',
        'communication',
        'conditionManagement',
        'consultCancelId',
        'consultEditId',
        'coverage',
        'doctorsAndPharmacies',
        'documents',
        'downloadApp',
        'emergency',
        'engagementTracker',
        'externalProviders',
        'expertMedicalOpinion',
        'family',
        'findBestDoctor',
        'food',
        'food.overview',
        'food.insights',
        'food.log',
        'food.intro',
        'food.passioSingleFoodItem',
        'food.passioFoodRecipe',
        'goalDownloadApp',
        'healthProfile',
        'home',
        'insights',
        'kidneyHealth',
        'log',
        'medicalHistory',
        'memberHealthRecord',
        'mentalHealth',
        'mentalHealthNavigator',
        'mentalHealthHome',
        'mentalHealthConnect',
        'mentalHealthGuide',
        'mentalHealthCrisis',
        'mentalHealthExplore',
        'mentalHealthPersonalization',
        'mentalHealthResources',
        'mentalHealthHistory',
        'oneAppReportsAndData',
        'oneAppOrderSupplies',
        'oneAppUserGuides',
        'partnerPrograms',
        'personalHealthNavigator',
        'pharmacy',
        'profilePreferences',
        'programs',
        'pulse',
        'pulse.overview',
        'pulse.trends',
        'pulse.allLogs',
        'pulse.summaryReport',
        'reminder',
        'reminder.setReminder',
        'security',
        'securityQuestions',
        'sexualHealth',
        'sitemap',
        'startGlp1Journey',
        'taskDetailPage',
        'tobaccoCessation',
        'vendorLandingPage',
        'visits',
        'weight',
        'weight.overview',
        'weight.trends',
        'weight.allLogs',
        'weight.summaryReport',
        'weight.getStarted',
        INBOX_SERVICE_TYPES.CareTeam,
        INBOX_SERVICE_TYPES.ChronicCare,
        NAV_MENU.MessageCenter.id,
        NAV_MENU.CareOptions.id,
    ],
    CallCenterRep: [
        'activateDevices',
        'allGenericRavRequest',
        'availablePrograms',
        'all-tasks',
        'backCare',
        'cardio-landing-page',
        'care-guide-activation',
        'healthInsightsReports',
        'bloodPressure',
        'bloodPressure.overview',
        'bloodPressure.trends',
        'bloodPressure.allLogs',
        'bloodPressure.usingYourMonitor',
        'bloodSugar',
        'bloodSugar.overview',
        'bloodSugar.trends',
        'bloodSugar.allLogs',
        'bloodSugar.friendsAndFamily',
        'bloodSugar.shareFromMeter',
        'bodyComposition',
        'bodyComposition.allLogs',
        'bodyComposition.overview',
        'bodyComposition.getStarted',
        'bodyComposition.summaryReport',
        'ccmSso',
        'coaching',
        'coaching.coachingSession',
        'coaching.coachingSessionDetails',
        'coaching.goals',
        'communication',
        'conditionManagement',
        'consultCancelId',
        'consultEditId',
        'doctorsAndPharmacies',
        'downloadApp',
        'emergency',
        'engagementTracker',
        'externalProviders',
        'expertMedicalOpinion',
        'family',
        'findBestDoctor',
        'food',
        'food.overview',
        'food.insights',
        'food.log',
        'food.intro',
        'food.passioSingleFoodItem',
        'food.passioFoodRecipe',
        'goalDownloadApp',
        'healthProfile',
        'home',
        'insights',
        'kidneyHealth',
        'log',
        'medicalHistory',
        'memberHealthRecord',
        'mentalHealth',
        'mentalHealthNavigator',
        'mentalHealthHome',
        'mentalHealthConnect',
        'mentalHealthGuide',
        'mentalHealthCrisis',
        'mentalHealthExplore',
        'mentalHealthPersonalization',
        'mentalHealthResources',
        'mentalHealthHistory',
        'oneAppOrderSupplies',
        'oneAppUserGuides',
        'personalHealthNavigator',
        'pharmacy',
        'profilePreferences',
        'programs',
        'pulse',
        'pulse.overview',
        'pulse.trends',
        'pulse.allLogs',
        'reminder',
        'reminder.setReminder',
        'security',
        'securityQuestions',
        'sexualHealth',
        'sitemap',
        'startGlp1Journey',
        'taskDetailPage',
        'tobaccoCessation',
        'visits',
        'weight',
        'weight.overview',
        'weight.trends',
        'weight.allLogs',
        'weight.getStarted',
    ],
    Member: [],
};

export default baseSchema;
